<div class="field" style="width:100%; display: flex;">
  @if (UserId == null) {
    <div class="ng-autocomplete position" (keypress)="KeyPress($event)" style="width:100%;">
      <ng-autocomplete
        [data]="SearchResults"
        [searchKeyword]="SearchOn"
        placeholder="Select user"
        (selected)='ItemSelected($event)'
        (inputChanged)='SearchChanged($event)'
        [itemTemplate]="itemTemplate"
        [notFoundTemplate]="notFoundTemplate"
        [debounceTime]="300"
        [isLoading]="IsLoading"
        (inputCleared)="Cleared()"
        >
      </ng-autocomplete>
    </div>
  }
  @if (AllowCreateUser && UserId == null) {
    <div class="control">
      <a class="button is-primary" (click)="addUser()">Add New User</a>
    </div>
  }

  <ng-template #itemTemplate let-item>
    <a>{{ item.FirstName }} {{ item.LastName }} ({{ item.Email }})</a>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div>{{ notFound }}</div>
  </ng-template>
</div>

